import React from 'react';
import {SingleLineText} from './SingleLineText';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import {formatDuration, wrapComponent} from "../utils";
import _ from 'lodash';
import {useField} from "formik";

export const Duration = ({ extraConfig, ...restProps }: FormPageFieldComponentProps) => {
  const [field, meta, helpers] = useField(restProps.name);
  let value = restProps.value
  const {format = 'h:mm'} = extraConfig
  const masks = {
    'h:mm': '9?9:99',
    'h:mm:ss': '9?9:99:99',
    'h:mm:ss.s': '9?9:99:99.9',
    'h:mm:ss.ss': '9?9:99:99.99',
    'h:mm:ss.sss': '9?9:99:99.999',
  }

  if(_.isNumber(value)){
    value = formatDuration(value, format)
    restProps['value'] = value

  }

  extraConfig = {...extraConfig, mask: masks[format], placeholder: format}
  console.log("DURATION INFO", format, extraConfig)
  const comp = <SingleLineText
      {...{extraConfig,...restProps}}  />
  return comp
};

export const DurationFormik = withFormikFormControl()(Duration);

export default DurationFormik;
